import request from '@/utils/request'
import { v2Host } from '@/config/host'
import { cookRequestParams } from '@/common/request'

// 获取用户反馈列表
export function getFeedbackList(params) {
  return request({
    url: `${v2Host}/website/message/list`,
    method: 'get',
    params: cookRequestParams(params),
  })
}
